export const handbookCopy = {
  handb_prev: "Previous",
  handb_next: "Next",
  handb_on_this_page: "On this page",
  handb_like_dislike_title: "Is this page helpful?",
  handb_like_desc: "Yes",
  handb_dislike_desc: "No",
  handb_thanks: "Thanks for the feedback",
  handb_deprecated_title: "This page has been deprecated",
  handb_deprecated_subtitle: "This handbook page has been replaced, ",
  handb_deprecated_subtitle_link: "go to the new page",
  handb_deprecated_subtitle_action: "Go to new page",
  handb_experimental_title: "This page contains experimental documentation",
  handb_experimental_subtitle: "The contents are about a work in progress topic.",

}
